// import React, { useEffect } from "react";
// import { Button, Typography, IconButton } from "@mui/material";
// import CreateIcon from "@mui/icons-material/Create";
// import MenuOpenIcon from "@mui/icons-material/MenuOpen";
// import MenuIcon from "@mui/icons-material/Menu";
// import HistoryIcon from "@mui/icons-material/History";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   createChat,
//   resetHistoryRefreshFlag,
//   loadSession,
//   clearChat,
// } from "../../store/chatSlice";
// import { AppDispatch, RootState } from "../../store";
// import ChatHistory from "../ChatHistory";
// import { UseChatHistory } from "../../hooks/UseChatHistory";
// import { useAuth } from "../../context/AuthContext";
// import clsx from "clsx";
// import LoadingSpinner from "../LoadingSpinner";
// import styles from "./sidebar.module.css";

// type SidebarProps = {
//   defaultOpen?: boolean;
//   onToggle?: (open: boolean) => void;
//   isHistoryIcon?: boolean;
//   sidebarOpen?: boolean;
//   onToggleSidebar?: () => void;
// };

// const Sidebar = ({
//   isHistoryIcon,
//   sidebarOpen,
//   onToggleSidebar,
// }: SidebarProps) => {
//   const dispatch = useDispatch<AppDispatch>();
//   const { getAccessToken } = useAuth();

//   // Get refresh flag and active session ID from Redux
//   const shouldRefreshHistory = useSelector(
//     (state: RootState) => state.chat.shouldRefreshHistory
//   );
//   const activeSessionId = useSelector(
//     (state: RootState) => state.chat.activeSessionId
//   );

//   // Fetch chat history from API
//   const {
//     recentChats,
//     olderChats,
//     allOlderChats,
//     loading,
//     deleteChat,
//     renameChat,
//     fetchRecentChats,
//   } = UseChatHistory();

//   // Wrap deletion to also clear active session state if the deleted session was loaded
//   const handleDeleteSession = async (sessionId: string) => {
//     await deleteChat(sessionId);
//     if (activeSessionId === sessionId) {
//       dispatch(clearChat());
//     }
//   };

//   // Watch for refresh flag and reload history when a new session is created
//   useEffect(() => {
//     if (shouldRefreshHistory) {
//       fetchRecentChats();
//       dispatch(resetHistoryRefreshFlag());
//     }
//   }, [shouldRefreshHistory, fetchRecentChats, dispatch]);

//   // Handle session selection
//   const handleSelectSession = async (sessionId: string) => {
//     try {
//       const token = await getAccessToken();
//       dispatch(loadSession({ sessionId, accessToken: token || undefined }));
//     } catch (error) {
//       // Session load error handled by Redux
//     }
//   };

//   // Transform to the format expected by ChatHistory component
//   const recentItems = recentChats.map((chat) => ({
//     id: chat.id,
//     title: chat.title || "Untitled Chat",
//     timestamp: chat.createdAt || "",
//   }));

//   const olderItems = olderChats.map((chat) => ({
//     id: chat.id,
//     title: chat.title || "Untitled Chat",
//     timestamp: chat.createdAt || "",
//   }));

//   const allOlderItems = allOlderChats.map((chat) => ({
//     id: chat.id,
//     title: chat.title || "Untitled Chat",
//     timestamp: chat.createdAt || "",
//   }));

//   return (
//     <div
//       className={clsx(styles.sidebarContainer, {
//         [styles.open]: sidebarOpen,
//         [styles.closed]: !sidebarOpen,
//       })}
//     >
//       <div className={styles.sidebarHeader}>
//         <IconButton
//           className={styles.menuButton}
//           aria-label={sidebarOpen ? "Close sidebar" : "Open sidebar"}
//           onClick={onToggleSidebar}
//         >
//           {sidebarOpen ? <MenuOpenIcon /> : <MenuIcon />}
//         </IconButton>
//         <Button
//           className={styles.newChatButton}
//           variant="contained"
//           size="small"
//           startIcon={<CreateIcon />}
//           onClick={() => dispatch(createChat("New Chat"))}
//         >
//           New
//         </Button>
//       </div>
//       {!sidebarOpen && (
//         <div className={styles.chatHistoryIcon}>
//           <IconButton
//             aria-label="Chat History"
//             title="Chat History"
//             onClick={onToggleSidebar}
//           >
//             <HistoryIcon />
//           </IconButton>
//         </div>
//       )}
//       <div className={styles.chatHistoryContainer}>
//         <Typography variant="h2">
//           <span>Chat History</span>
//           {isHistoryIcon && (
//             <IconButton
//               aria-label="Clear Chat History"
//               title="Clear"
//               className={styles.clearButton}
//             >
//               <HistoryIcon />
//             </IconButton>
//           )}
//         </Typography>
//         {loading ? (
//           <div className={styles.loadingContainer}>
//             <LoadingSpinner inline size="sm" label="Loading chat history..." />
//           </div>
//         ) : (
//           <>
//             <ChatHistory
//               title="Previous 7 Days"
//               sectionKey="previous7days"
//               items={recentItems}
//               onDelete={handleDeleteSession}
//               onRename={renameChat}
//               onSelect={handleSelectSession}
//               activeItemId={activeSessionId}
//             />
//             <ChatHistory
//               title="Previous 30 Days"
//               sectionKey="previous30days"
//               items={olderItems}
//               onDelete={handleDeleteSession}
//               onRename={renameChat}
//               onSelect={handleSelectSession}
//               activeItemId={activeSessionId}
//             />
//             <ChatHistory
//               title="Older"
//               sectionKey="older"
//               items={allOlderItems}
//               onDelete={handleDeleteSession}
//               onRename={renameChat}
//               onSelect={handleSelectSession}
//               activeItemId={activeSessionId}
//             />
//           </>
//         )}
//       </div>
//     </div>
//   );
// };
// export default Sidebar;

import React, { useEffect } from "react";
import { Button, Typography, IconButton } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";
import HistoryIcon from "@mui/icons-material/History";
import { useDispatch, useSelector } from "react-redux";
import {
  createChat,
  resetHistoryRefreshFlag,
  loadSession,
  clearChat,
} from "../../store/chatSlice";
import { AppDispatch, RootState } from "../../store";
import ChatHistory from "../ChatHistory";
import { UseChatHistory } from "../../hooks/UseChatHistory";
import { useAuth } from "../../context/AuthContext";
import clsx from "clsx";
import LoadingSpinner from "../LoadingSpinner";
import styles from "./sidebar.module.css";

type SidebarProps = {
  isHistoryIcon?: boolean;
  sidebarOpen?: boolean;
  onToggleSidebar?: () => void;
};

const Sidebar = ({
  isHistoryIcon,
  sidebarOpen,
  onToggleSidebar,
}: SidebarProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessToken } = useAuth();

  const shouldRefreshHistory = useSelector(
    (state: RootState) => state.chat.shouldRefreshHistory
  );
  const activeSessionId = useSelector(
    (state: RootState) => state.chat.activeSessionId
  );

  // ✅ Use fixed hook
  const {
    recentChats,
    olderChats,
    allOlderChats,
    loading,
    deleteChat,
    renameChat,
    fetchAll,
    hasMoreRecent,
    hasMoreOlder,
    hasMoreAllOlder,
    loadMoreRecent,
    loadMoreOlder,
    loadMoreAllOlder,
    loadingMoreRecent,
    loadingMoreOlder,
    loadingMoreAllOlder,
    // Lazy loading props
    fetchOlderSection,
    fetchAllOlderSection,
    loadingOlderSection,
    loadingAllOlderSection,
  } = UseChatHistory();

  // Clear active session if deleted
  const handleDeleteSession = async (sessionId: string) => {
    await deleteChat(sessionId);
    if (activeSessionId === sessionId) {
      dispatch(clearChat());
    }
  };

  // ✅ Refresh history properly
  useEffect(() => {
    if (shouldRefreshHistory) {
      fetchAll();
      dispatch(resetHistoryRefreshFlag());
    }
  }, [shouldRefreshHistory, fetchAll, dispatch]);

  // Load selected session
  const handleSelectSession = async (sessionId: string) => {
    try {
      const token = await getAccessToken();
      dispatch(loadSession({ sessionId, accessToken: token || undefined }));
    } catch {
      // handled in redux
    }
  };

  // Map data for ChatHistory
  const mapItems = (chats: any[]) =>
    chats.map((chat) => ({
      id: chat.id,
      title: chat.title || "Untitled Chat",
      timestamp: chat.createdAt || "",
    }));

  return (
    <div
      className={clsx(styles.sidebarContainer, {
        [styles.open]: sidebarOpen,
        [styles.closed]: !sidebarOpen,
      })}
    >
      <div className={styles.sidebarHeader}>
        <IconButton
          className={styles.menuButton}
          onClick={onToggleSidebar}
          aria-label={sidebarOpen ? "Close sidebar" : "Open sidebar"}
        >
          {sidebarOpen ? <MenuOpenIcon /> : <MenuIcon />}
        </IconButton>

        <Button
          className={styles.newChatButton}
          variant="contained"
          size="small"
          startIcon={<CreateIcon />}
          onClick={() => dispatch(createChat("New Chat"))}
        >
          New
        </Button>
      </div>

      {!sidebarOpen && (
        <div className={styles.chatHistoryIcon}>
          <IconButton onClick={onToggleSidebar} title="Chat History">
            <HistoryIcon />
          </IconButton>
        </div>
      )}

      <div className={styles.chatHistoryContainer}>
        <Typography variant="h2">
          <span>Chat History</span>
          {isHistoryIcon && (
            <IconButton className={styles.clearButton} title="Clear">
              <HistoryIcon />
            </IconButton>
          )}
        </Typography>

        {loading ? (
          <div className={styles.loadingContainer}>
            <LoadingSpinner inline size="sm" label="Loading chat history..." />
          </div>
        ) : (
          <>
            <ChatHistory
              title="Previous 7 Days"
              sectionKey="previous7days"
              items={mapItems(recentChats)}
              onDelete={handleDeleteSession}
              onRename={renameChat}
              onSelect={handleSelectSession}
              activeItemId={activeSessionId}
              hasMore={hasMoreRecent}
              onLoadMore={loadMoreRecent}
              loadingMore={loadingMoreRecent}
            />

            <ChatHistory
              title="Previous 30 Days"
              sectionKey="previous30days"
              items={mapItems(olderChats)}
              onDelete={handleDeleteSession}
              onRename={renameChat}
              onSelect={handleSelectSession}
              activeItemId={activeSessionId}
              hasMore={hasMoreOlder}
              onLoadMore={loadMoreOlder}
              loadingMore={loadingMoreOlder}
              onExpand={fetchOlderSection}
              loadingSection={loadingOlderSection}
            />

            <ChatHistory
              title="Older"
              sectionKey="older"
              items={mapItems(allOlderChats)}
              onDelete={handleDeleteSession}
              onRename={renameChat}
              onSelect={handleSelectSession}
              activeItemId={activeSessionId}
              hasMore={hasMoreAllOlder}
              onLoadMore={loadMoreAllOlder}
              loadingMore={loadingMoreAllOlder}
              onExpand={fetchAllOlderSection}
              loadingSection={loadingAllOlderSection}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Sidebar;


